/* eslint-disable */
import Amplify, { Auth } from "aws-amplify";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
  CognitoRefreshToken,
} from "amazon-cognito-identity-js";
import { IAuthAWS, IOAuth } from "../interfaces/IAuthAWS";
import { FederatedSignInOptions } from "@aws-amplify/auth/lib-esm/types";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import * as AWS from "aws-sdk";
// import { Alert, Platform } from 'react-native';

// import InAppBrowser from 'react-native-inappbrowser-reborn';

import { SocialMedia } from "../interfaces/IAuthFunctionalities";
import { IUserAuth } from "../interfaces/IUserAuth";
import {
  changePhone,
  confirmChangeEmail,
  confirmChangePhone,
  adminInviteUser,
  adminAddUserToGroup,
  adminListGroupsForUser,
} from "services/cognito";
import { AWS_CONFIG, AWS_CREDENTIALS } from "config/config";
let userPool: CognitoUserPool;
let currentUser: CognitoUser;

export const initCognito = async (authProps: IAuthAWS) => {
  const poolData: any = {
    UserPoolId: authProps.userPoolId,
    ClientId: authProps.userPoolWebClientId,
  };
  Amplify.configure(authProps);
  userPool = new CognitoUserPool(poolData);

  if (userPool) currentUser = <CognitoUser>userPool.getCurrentUser();
  else currentUser = await Auth.currentAuthenticatedUser();
};

export const getCurrentUser = async () => {
  currentUser = await Auth.currentAuthenticatedUser();
  return currentUser;
};

function getCognitoUser(username: string) {
  const userData = {
    Username: username,
    Pool: userPool,
  };
  if (!currentUser) {
    const cognitoUser = new CognitoUser(userData);
    return cognitoUser;
  } else {
    if (currentUser.getUsername() !== username) {
      const cognitoUser = new CognitoUser(userData);
      return cognitoUser;
    }
  }
  return currentUser;
}

export async function getSession() {
  return new Promise(function (resolve, reject) {
    Auth.currentSession()
      .then((session: any) => {
        resolve(session);
      })
      .catch((err: any) => {
        reject(err);
      });
  }).catch((err) => {
    throw err;
  });
}

export async function signUpUserWithEmail(
  username: string,
  email: string,
  password: string
) {
  return new Promise(function (resolve, reject) {
    const attributeList = [
      new CognitoUserAttribute({
        Name: "email",
        Value: email,
      }),
    ];

    userPool.signUp(
      username,
      password,
      attributeList,
      [],
      function (err: any, res: any) {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      }
    );
  }).catch((err: any) => {
    throw err;
  });
}

export async function signUpUserWithPhone(
  username: string,
  email: string,
  password: string,
  phone: string,
  name?: string,
  firstName?: string,
  lastName?: string
) {
  return new Promise(function (resolve, reject) {
    const attributeList = [
      new CognitoUserAttribute({
        Name: "email",
        Value: email,
      }),
      new CognitoUserAttribute({
        Name: "phone_number",
        Value: phone,
      }),
      new CognitoUserAttribute({
        Name: "name",
        Value: firstName as string,
      }),
      new CognitoUserAttribute({
        Name: "family_name",
        Value: lastName as string,
      }),
    ];

    userPool.signUp(
      username,
      password,
      attributeList,
      [],
      function (err: any, res: any) {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      }
    );
  }).catch((err) => {
    throw err;
  });
}

export async function verifyCode(username: string, code: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);

    cognitoUser.confirmRegistration(
      code,
      true,
      function (err: any, result: any) {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      }
    );
  }).catch((err) => {
    throw err;
  });
}

export let mfaRequired = false;
let authenticationDetails: AuthenticationDetails;

export async function signInWithEmail(
    username: string,
    password: string,
    callback: (type: 'mfa' | 'password') => void,
    setMfaRequired: (required: boolean) => void,
) {
  return new Promise(function (resolve, reject) {
    const authenticationData = {
      Username: username,
      Password: password,
    };

    authenticationDetails = new AuthenticationDetails(authenticationData);

    currentUser = getCognitoUser(username);

    currentUser.authenticateUser(authenticationDetails, {
      mfaRequired() {
        // Implement you functionality to show UI for MFA form
        mfaRequired = true;
        setMfaRequired(true);
        callback("mfa");
      },
      newPasswordRequired() {
        mfaRequired = false;
        callback("password");
      },
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  }).catch((err) => {
    throw err;
  });
}

export async function signInOTP(username: string, password: string) {
  return new Promise(function (resolve, reject) {
    const authenticationData = {
      Username: username,
      Password: password,
    };

    authenticationDetails = new AuthenticationDetails(authenticationData);
    currentUser = getCognitoUser(username);

    Auth.signIn(username, password)
      .then((user) => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          throw {
            code: "NEW_PASSWORD_REQUIRED",
            message: "Please change your password to have access to the system",
          };
        } else {
          resolve(user);
          // other situations
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const sendMfaCode = (username: string, MFACode: string) => {
  return new Promise(function (resolve, reject) {
    currentUser.sendMFACode(MFACode, {
      onSuccess: function (res: any) {
        mfaRequired = false;
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  });
};

export const reSendMfaCode = (callback: (sended: boolean) => void) => {
  if (!currentUser || !authenticationDetails) {
    callback(false);
  }
  return new Promise(function (resolve, reject) {
    currentUser.authenticateUser(authenticationDetails, {
      mfaRequired() {
        // Implement you functionality to show UI for MFA form
        mfaRequired = true;
        callback(true);
      },
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  });
};

export const federatedSignIn = (configAWS: IAuthAWS, provider: SocialMedia) => {
  const updatedConfig: IAuthAWS = {
    ...configAWS,
    oauth: {
      ...(<IOAuth>configAWS.oauth),
      urlOpener: federatedSignInUrlOpener,
    },
  };
  Amplify.configure(updatedConfig);
  const signInOption: FederatedSignInOptions = {
    provider: <CognitoHostedUIIdentityProvider>(<unknown>provider),
  };
  Auth.federatedSignIn(signInOption);
};

const federatedSignInUrlOpener = async (url: any, redirectUrl: any) => {
  // try {
  //   if (await InAppBrowser.isAvailable()) {
  //     const result = await InAppBrowser.openAuth(url, getDeepLink(), {
  //       // iOS Properties
  //       ephemeralWebSession: false,
  //       // Android Properties
  //       showTitle: false,
  //       enableUrlBarHiding: true,
  //       enableDefaultShare: false,
  //     });
  //     // Alert.alert('Response', JSON.stringify(result));
  //   } else {
  //     // Alert.alert('InAppBrowser is not supported :/');
  //   }
  // } catch (err) {
  //   // Alert.alert('Something’s wrong with the app :(');
  // }
};

export const getDeepLink = (path = "") => {
  const scheme = "topflightapps";
  // const prefix = Platform.OS == 'android' ? `${scheme}://authentication/` : `${scheme}://`
  // return prefix + path
  return path;
};

export function signOut(redirect?: boolean) {
  if (currentUser) {
    currentUser.signOut();
    if (redirect) {
      window.location.href = "/SignIn";
    }
  }
}

export async function getAttributes() {
  if (!currentUser) currentUser = await getCurrentUser();

  return new Promise(function (resolve, reject) {
    currentUser.getUserAttributes(function (err: any, attributes: any) {
      if (err) {
        reject(err);
      } else {
        resolve(attributes);
      }
    });
  }).catch((err) => {
    throw err;
  });
}

export async function setAttribute(attribute: any) {
  return new Promise(function (resolve, reject) {
    const attributeList = [];
    const res = new CognitoUserAttribute(attribute);
    attributeList.push(res);

    currentUser.updateAttributes(attributeList, (err: any, res: any) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  }).catch((err) => {
    throw err;
  });
}

export async function setAttributes(attributes: IUserAuth) {
  return new Promise(function (resolve, reject) {
    const attr = attributes.attr;
    const attributeList = [
      new CognitoUserAttribute({
        Name: "email",
        Value: attributes.email,
      }),
      new CognitoUserAttribute({
        Name: "phone_number",
        Value: attributes.phone_number,
      }),
      new CognitoUserAttribute({
        Name: "name",
        Value: attributes.name as string,
      }),
    ];

    currentUser.updateAttributes(attributeList, (err: any, res: any) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  }).catch((err) => {
    throw err;
  });
}

export async function sendCodeForgotPassword(username: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);

    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    cognitoUser.forgotPassword({
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  }).catch((err) => {
    throw err;
  });
}

export async function sendCodeRecoverPassword(username: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);
    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    cognitoUser.forgotPassword({
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  }).catch((err) => {
    throw err;
  });
}

export async function forgotPassword(
  username: string,
  code: string,
  password: string
) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);
    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    cognitoUser.confirmPassword(code, password, {
      onSuccess: function () {
        resolve("password updated");
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  });
}

export async function forgotPasswordToken(username: string, password: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);
    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    /* cognitoUser.confirmPassword(code, password, {
      onSuccess: function () {
        resolve('password updated')
      },
      onFailure: function (err) {
        reject(err)
      },
    }) */
  });
}

export const updatePhone = (phone: string, username: string) => {
  return new Promise(function (resolve, reject) {
    AWS.config.update({
      region: AWS_CONFIG.region,
      accessKeyId: AWS_CREDENTIALS.accessKeyId,
      secretAccessKey: AWS_CREDENTIALS.secretAccessKey,
    });
    let cognitoIdentityServiceProvider =
      new AWS.CognitoIdentityServiceProvider();

    let parameters = {
      UserPoolId: AWS_CONFIG.userPoolId || "",
      Username: username,
      UserAttributes: [
        {
          Name: "phone_number",
          Value: phone,
        },
      ],
    };

    cognitoIdentityServiceProvider.adminUpdateUserAttributes(
      parameters,
      function (err, result) {
        if (err) reject(err);
        else resolve(result);
      }
    );
  });
};

export async function changePassword(oldPassword: string, newPassword: string) {
  const user = await Auth.currentAuthenticatedUser();
  try {
    const response = await Auth.changePassword(user, oldPassword, newPassword);
    return response;
  } catch (error: any) {
    return error.message;
  }
}

export async function signUpAdmin(email: string) {
  try {
    const res = await adminInviteUser(email);
    return res;
  } catch (e) {
    throw e;
  }
}

export async function addUserToGroup(email: string, groupName: string) {
  try {
    const res = await adminAddUserToGroup(email, groupName);
    return res;
  } catch (e) {
    throw e;
  }
}

export async function listGroupsForUser(email: string) {
  try {
    const res = await adminListGroupsForUser(email);
    return res;
  } catch (e) {
    throw e;
  }
}

export async function completeNewPassword(
  username: string,
  password: string,
  newPassword: string
) {
  return new Promise(function (resolve, reject) {
    Auth.signIn(username, password)
      .then((user) => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
          Auth.completeNewPassword(
            user, // the Cognito User Object
            newPassword, // the new password
            // OPTIONAL, the required attributes
            {
              phone_number: "+1234567890",
            }
          )
            .then((user) => {
              // at this time the user is logged in if no MFA required
              resolve(user);
            })
            .catch((e) => {
              reject(e);
            });
        } else {
          resolve(user);
          // other situations
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export const sendCode = (username: string, code: string) => {
  const cognitoUser = getCognitoUser(username);
  return new Promise(function (resolve, reject) {
    cognitoUser.confirmRegistration(
      code,
      true,
      function (err: any, result: any) {
        if (err) {
          reject(err);
        }
        resolve(result);
      }
    );
  });
};

export const reSendCode = async (username: string) => {
  const cognitoUser = getCognitoUser(username);
  return new Promise(function (resolve, reject) {
    cognitoUser.resendConfirmationCode(function (err: any, result: any) {
      if (err) {
        reject(err);
      }
      resolve(result);
    });
  });
};

export const enableMFA = async (username: string) => {
  currentUser = await Auth.currentAuthenticatedUser();
  const smsMfaSettings = {
    PreferredMfa: true,
    Enabled: true,
  };
  return new Promise(function (resolve, reject) {
    currentUser.setUserMfaPreference(
      smsMfaSettings,
      null,
      function (err, result) {
        if (err) {
          //alert(err.message || JSON.stringify(err));
          reject(err);
        }
        resolve(result);
      }
    );
  });
};

export const disableMFA = async (username: string) => {
  currentUser = await Auth.currentAuthenticatedUser();
  const smsMfaSettings = {
    PreferredMfa: false,
    Enabled: false,
  };
  return new Promise(function (resolve, reject) {
    currentUser.setUserMfaPreference(
      smsMfaSettings,
      null,
      function (err, result) {
        if (err) {
          //alert(err.message || JSON.stringify(err));
          reject(err);
        }
        resolve(result);
      }
    );
  });
};

export const rememberDevice = () => {
  return new Promise(async function (resolve, reject) {
    try {
      currentUser.setDeviceStatusRemembered({
        onSuccess: function (result: any) {
          resolve(result);
        },
        onFailure: function (err: any) {
          reject(err);
        },
      });
    } catch (err: any) {
      reject(err);
    }
  });
};

export const forgotDevice = () => {
  return new Promise(async function (resolve, reject) {
    try {
      currentUser.forgetDevice({
        onSuccess: function (result: any) {
          resolve(result);
        },
        onFailure: function (err: any) {
          reject(err);
        },
      });
    } catch (err: any) {
      reject(err);
    }
  });
};

export const onChangePhoneSubmitted = async (phone: string, email: string) => {
  try {
    const user = await Auth.currentAuthenticatedUser();

    if (user.attributes.phone_number === phone) {
      throw new Error(`${phone} is already your phone number`);
    }
    await changePhone(phone, email);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e) {
    throw e;
  }
};

export const onConfirmCodeResendCodePhone = async (
  phone: string,
  email: string
) => {
  try {
    await changePhone(phone, email);
    return true;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const onConfirmCodeSubmitted = async (
  code: string,
  NewEmail: string,
  email: string
) => {
  try {
    await Auth.currentAuthenticatedUser();
    await confirmChangeEmail(code, NewEmail, email);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const onConfirmCodeSubmittedPhone = async (
  code: string,
  phone: string,
  email: string
) => {
  try {
    await confirmChangePhone(code, phone, email);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

const refreshToken = (username: string, refreshT: string) => {
  const newToken = new CognitoRefreshToken({ RefreshToken: refreshT });
  if (!currentUser) currentUser = getCognitoUser(username);
  return new Promise(function (resolve, reject) {
    currentUser.refreshSession(newToken, function (err, result) {
      if (err) {
        reject(err);
      }
      resolve(result);
    });
  });
};

/**
 * Yes, it's a huge workaround ¯\_(ツ)_/¯
 * But it's the only quick solutiom that I found
 */
declare global {
  interface Window {
    initCognito: typeof initCognito;
    getCurrentCognitoUser: typeof getCurrentUser;
    cognitoRefreshToken: typeof refreshToken;
  }
}

window.cognitoRefreshToken = refreshToken;
window.initCognito = initCognito;
window.getCurrentCognitoUser = getCurrentUser;
